import { Environment, Region } from '@bringg/frontend-utils/dist/common/types';

const DEFAULT_REGION = 'default_region';

export default class RegionService {
	private readonly configuration: Environment;

	constructor(config: Environment) {
		this.configuration = config;
	}

	getConfigByRegion(): Region {
		const regionId = Number(this.getRegionFromUrl());
		const regionValues = this.configuration?.regions && Object.values(this.configuration.regions);
		let region = regionValues?.find(region => region['id'] === regionId);

		// Prepare move to US3
		// This code needs to be removed 2 months after the migration to US3
		// If region 2 (US1) is not present in json config, this means that we need to redirect to regionId 8 (US3)
		if (regionValues && !region && regionId === 2) {
			region = regionValues.find(region => region['id'] === 8);
		}

		return region || this.getDefaultRegion();
	}

	private getDefaultRegion(): Region {
		return this.configuration.regions[this.configuration[DEFAULT_REGION]];
	}

	private getRegionFromUrl() {
		const urlParams = new URLSearchParams(window.location.hash);

		if (urlParams) {
			return urlParams.get('e');
		}
	}
}
